export const useShowNewPdpUI = () => {
  return true
}
